<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    console.log('login page')

    var token = this.$getUrlKey('ei_token')
    var redirect = this.$getUrlKey('r')
    window.localStorage.setItem('ei_token', token)
    console.log('login token:' + window.localStorage.getItem('ei_token'))
    if (redirect || redirect != 'null') {
      window.location.href = redirect
    } else {
      window.location.href = '/'
    }
  }
}
</script>
